import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../services/TokenService'
import ReCAPTCHA from "react-google-recaptcha";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LoadingIndicator from './LoadingIndicator'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function PasswordReset(props) {
    const requestGuid = useRef();
    const requestGuid2 = useRef();
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [resetComplete, setResetComplete] = useState('');
    const [requestType, setRequestType] = useState('');
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });

    useEffect(() => {
        // first load processing
        console.log("First load");
        let queryParams = new URLSearchParams(window.location.search);
        requestGuid.current = queryParams.get("r");
        


        if (requestGuid.current != null) {
            setIsLoading(true);

            let postData = {
                requestGuid: requestGuid.current
            }

            //
            TokenService.post(postData, 'PasswordResetVerify', '')
                .then((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            let data = JSON.parse(response.JsonData);

                            requestGuid2.current = data.ResetGuid2;
                            setRequestType(data.RequestType);
                        }
                        else if (response.Result === "FAIL") {

                            setErrorMessage(response.Message);
                        }
                    }
                })
                .catch((response) => {
                    setIsLoading(false);
                    if (response !== null) {
                        if (response.Result === "FAIL") {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }

                    }
                });

        }
        else {
            setErrorMessage("Oops, you shouldn't see this. Your link was missing some info we need to help you reset your password.");
        }



    }, []) // <-- empty dependency array to prevent this from running every update

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            validate();
        }
    }

    function redirect(userType) {
        if (userType == 'Client') {
            window.location.href = window.location.protocol + '//' + window.location.host + '/Portal'
        }
        else {
            window.location.href = window.location.protocol + '//' + window.location.host + '/recycler/';
        }
    }

    function validate() {
        let isValid = true;
        let errors = [];

        if (password.trim() === '') {
            errors["Password"] = "New Password is required";
            isValid = false;
        }
        else if (password2.trim() === '') {
            errors["Password2"] = "Re-enter your new Password";
            isValid = false;
        }
        else if (password.trim() != password2.trim()) {
            errors["Password2"] = "Passwords do not match.";
            isValid = false;
        }

        else if (password.trim().length < 5) {
            errors["Password"] = "Must be at least 5 characters long.";
            isValid = false;
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        if (isValid) {
            setIsLoading(true);
            //TokenService
            let postData = {
                requestGuid: requestGuid.current,
                requestGuid2: requestGuid2.current,
                password: password
            }

            TokenService.post(postData, 'PasswordResetComplete', '')
                .then((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            let userType = response.JsonData;
                            setResetComplete(<div>
                                <div>Your password has been {requestType == 'register' ? 'created' : 'reset'}.</div>
                                <div>Click below to login:</div>
                                <Button style={{ marginTop: '15px', alignSelf: 'center' }} variant='contained' color="sipzeeGreen" onClick={(e) => redirect(userType)}>Login</Button>
                            </div>)
                        }
                        else {
                            setErrorMessage(response.Message);
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {
                        if (response.Result === "FAIL") {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }

                    }
                });

        }


    }

    function showLoading() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
                flexDirection="column"
            >
                <div style={{ marginBottom: '10px', marginTop: '10px' }}>Verifying</div>
                <CircularProgress color="secondary" />
            </Box>)
    }

    function resetPanel() {
        return <div className={'ContactSectionBody'}>
            <div>{requestType == 'register' ? 'Set' : 'Reset'} your Password</div>
            <TextField className={'ContactSectionText'} error={formValidation.errors['Password'] !== undefined} label="Password" onChange={(e) => setPassword(e.target.value)} value={password} variant="outlined" type="password" onKeyDown={handleKeyDown} />
            <div className={'FormFieldErrorDescription'} style={{ textAlign: 'center' }}> {formValidation.errors['Password'] !== undefined ? formValidation.errors['Password'] : ''}</div>

            <TextField className={'ContactSectionText'} style={{ marginTop: '20px' }} error={formValidation.errors['Password2'] !== undefined} label="Re-enter" onChange={(e) => setPassword2(e.target.value)} value={password2} variant="outlined" type="password" onKeyDown={handleKeyDown} />
            <div className={'FormFieldErrorDescription'} style={{ textAlign: 'center' }}> {formValidation.errors['Password2'] !== undefined ? formValidation.errors['Password2'] : ''}</div>

            <div>
                <Button style={{ marginTop: '15px', alignSelf: 'center' }} variant='contained' color="sipzeeGreen" onClick={(e) => validate()}>{requestType == 'register' ? 'Create' : 'Reset'}</Button>
            </div>
        </div>

    }

    return (<div>
        <Card sx={{ minWidth: 300, maxWidth: 400, alignSelf: 'center', margin: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
            <CardContent>
                <div >
                   
                    {isLoading ? showLoading() :
                        errorMessage != '' ? null :
                            resetComplete != '' ? null :

                                resetPanel()
                    }
                </div>

                {errorMessage}
                {resetComplete }

            </CardContent>
        </Card>

    </div>)
}